import { render, staticRenderFns } from "./ServiceBreakdownList.vue?vue&type=template&id=06b2995a&scoped=true&"
import script from "./ServiceBreakdownList.vue?vue&type=script&lang=js&"
export * from "./ServiceBreakdownList.vue?vue&type=script&lang=js&"
import style0 from "./ServiceBreakdownList.vue?vue&type=style&index=0&id=06b2995a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b2995a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
